<script>
import Website from '@wielink-application/shared/vue/components/form/horizontal/website.vue'

export default Website;
</script>